<style lang="scss" scoped>
.container {
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  display: flex;
  width: 100%;
  min-height: 0;

  .card-container {
    flex: 2;
    display: flex;
    width: 100%;
    justify-content: center;
    background-color: #f5f5f5;
    // height: calc(100% - 15px);
    align-items: center;
    box-shadow: 0px 4px 10px 0px rgba(110, 122, 141, 0.06);

    /deep/ .el-form-item__label {
      padding: 0;
    }

    /deep/ .el-select .el-input {
      width: 100%;
    }
  }

  .right-container {
    flex: 9;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    width: 100%;

    .chat-container {
      flex: 9;
      min-width: 400px;
      height: 100%;
      display: flex;
      justify-content: center;

      .chat-box {
        width: 95%;
        display: flex;
        flex-direction: column;
        padding-bottom: 30px;

        .chat-header {
          display: flex;
          justify-content: flex-start;
          padding: 16px;

          span {
            font-size: 15px;
          }
        }

        .message-container {
          flex: 1;
          overflow-y: auto;
          background: #fff;
          padding: 0 16px 20px 16px;

          .msg-buttons {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .msg-button {
              padding: 5px 10px;
              background-color: #fff;
              border: 1px solid #d9d9d9;
              border-radius: 12px;
              cursor: pointer;
            }

            .msg-button:hover {
              border: 1px solid #68c13c;
            }
          }

          .user-message {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;
            padding-bottom: 45px;

            div {
              border-radius: 12px 2px 12px 12px;
              padding: 12px 16px;
              background: #f3f3f3;
              font-size: 15px;
            }
          }

          .bot-message {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            font-size: 15px;
            font-family: 'Microsoft YaHei', sans-serif;

            /deep/ p {
              padding: 0 0 10px 0 !important;
            }
          }

          .quote {
            padding: 5px 10px;
            margin-bottom: 15px;
            border-left: 2px solid #e8e8e8;
            background-color: #fcfcfc;
            color: #656565;
            font-size: 14px;

            /deep/ p {
              padding: 10px 0 !important;
            }
          }
        }

        .shortCutKeys {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding: 0 10px 0 10px;

          .shortCutKey {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #fff;
            height: 40px;
            padding-right: 10px;

            > div {
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 5px 8px;
              border: 1px solid #d9d9d9;
              border-radius: 5px;
              cursor: pointer;
              font-size: 12px;
              color: #606266;
            }

            > div:hover {
              border: 1px solid #68c13c;
            }
          }
        }

        .input-container {
          position: relative;
          display: inline-block;

          .chat-input {
            outline: none;
            border: 1px solid #d9d9d9;
            border-radius: 12px;
            box-shadow: 0px 4px 10px 0px rgba(65, 77, 96, 0.06);
            font-size: 14px;
            padding-right: 40px;
            padding-left: 10px;
            width: 100%;
            height: 48px;
            background-color: #fff;
          }

          .chat-input:focus {
            border: 1px solid #68c13c;
          }

          .icon-button {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            background: none;
            border: none;
            cursor: pointer;
            padding-right: 9px;
            margin-right: 1px;
          }

          .icon-button i {
            background-color: #fff;
            font-size: 24px;
            color: #68c13c;
          }

          .icon-button:disabled {
            background-color: #fff;
            cursor: not-allowed;
          }

          /* 禁用状态下更改图标颜色 */
          .icon-button:disabled i {
            background-color: #fff;
            color: #bababa;
          }
        }

        .connection-status {
          text-align: center;
          color: #e6a23c;
          background: #fff;
          border-radius: 4px;
          padding-top: 10px;
        }
      }
    }

    .history-container {
      flex: 2;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #f5f5f5;
      width: 100%;
      min-width: 0;
      // height: calc(100% - 15px);
      // box-shadow: 0px 4px 10px 0px rgba(110, 122, 141, 0.06);

      .history-header {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 20px;
        position: sticky;
        top: 0;

        .new-chat-button {
          height: 38px;
          width: 100%;
          margin: 12px;
          background-color: #ffffff;

          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.9);
          border-radius: 8px;
          cursor: pointer;
        }

        .new-chat-button:hover {
          border: 1px solid #e2e2e2;
        }
      }

      .history-list {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow-y: auto;
        width: 100%;
        padding: 0 12px 12px 12px;

        .history-item {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 40px;
          font-size: 14px;
          line-height: 22px;
          color: #181818;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding: 9px 8px;
        }

        .history-item:hover {
          cursor: pointer;
          background-color: #e8e8e8;
          border-radius: 8px;
        }

        .selected {
          cursor: pointer;
          background-color: #e8e8e8;
          border-radius: 8px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="container">
    <div class="card-container">
      <div style="width: 90%;">
        <el-form :inline="false" label-position="top" :model="cardForm">
          <el-form-item :label="$t('qingxuanzeyitaishebei')" required>
            <yi_data_select type="equipmentAll" :queryFilter="e => e.typeId === 1" :ids.sync="cardForm.equipmentId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('qingxuanzeyizhongyuancailiao')" required>
            <el-select v-model="cardForm.srcMaterial" clearable :placeholder="$t('qingxuanze')">
              <el-option v-for="(item, index) in srcMaterials" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('qingxuanzeyizhongchanpinleixing')" required>
            <el-select v-model="cardForm.product" clearable :placeholder="$t('qingxuanze')">
              <el-option v-for="(item, index) in products" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('qingxuanzeyizhonghuoduozhongquexian')" required>
            <el-select v-model="cardForm.defectIds" clearable :placeholder="$t('qingxuanze')" multiple collapse-tags filterable>
              <el-option v-for="(item, index) in defectList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" :rows="5" v-model="cardForm.remark"> </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="right-container">
      <div class="chat-container">
        <div class="chat-box">
          <div class="chat-header" v-show="messages.length === 0">
            <span>Hi~ 我是小YI 你身边的智能助手，可以为你实时分析生产过程关键工艺参数，自动计算并推荐工艺参数以达到最优生产状态</span>
          </div>
          <div class="message-container" ref="messageContainer" v-loading="chatLoading" @scroll="handleScroll">
            <div v-for="(item, index) in messages" :key="index">
              <div v-if="item.type === 'bot'" style="padding-bottom: 45px;">
                <div v-if="!item.msg && !item.reasoningMsg">
                  <i class="el-icon-loading" style="font-size: 18px;"></i>
                </div>
                <div v-else>
                  <div class="bot-message quote" v-if="item.reasoningMsg" v-html="renderMarkdown(item.reasoningMsg)"></div>
                  <div class="bot-message" v-if="item.msg" v-html="renderMarkdown(item.msg)"></div>
                  <div class="msg-buttons">
                    <div v-if="item.msg" class="msg-button" v-show="item.msg.includes('建议参数')" @click="sendPoint(item)">下发工艺参数</div>
                  </div>
                </div>
              </div>
              <div v-else class="user-message">
                <div>{{ item.msg }}</div>
              </div>
            </div>
          </div>
          <div class="shortCutKeys">
            <div v-for="(item, index) in shortCutKeys" :key="index" class="shortCutKey">
              <div @click="handleShortCutKey(item)">{{ item }}</div>
            </div>
          </div>
          <div class="input-container">
            <input class="chat-input" v-model="inputMsg" @keyup.enter="sendMessage" placeholder="输入您的问题..." :disabled="!isConnected" />
            <button class="icon-button" @click="sendMessage" :disabled="!isConnected || inputMsg.trim() === ''">
              <i class="el-icon-s-promotion"></i>
            </button>
          </div>
          <div v-show="!isConnected" class="connection-status">连接已断开，正在重新连接: {{ reconnectAttempts }}...</div>
        </div>
      </div>
      <div class="history-container" v-show="historyItems.length > 0">
        <div class="history-header">
          <div class="new-chat-button" @click="newConversation">新建对话</div>
        </div>
        <div class="history-list">
          <div v-for="(item, index) in historyItems" :key="index">
            <div class="history-item" :class="{ selected: historyIndex === index }" @click="selectItem(item, index)">{{ item.remark }} {{ dayjs(item.createTime).format('MM-DD HH:mm') }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 选择下发工艺参数弹窗 -->
    <choosePointDialog v-if="cardForm.equipmentId" :show.sync="choosePointVisible" :answer="currentAnswer" :equipmentId="cardForm.equipmentId"></choosePointDialog>
  </div>
</template>

<script type="text/javascript">
import SockJS from 'sockjs-client';
const marked = require('marked');
import choosePointDialog from './dialog/choosePointDialog.vue';
import dayjs from 'dayjs';

marked.setOptions({
  gfm: true,
  breaks: true,
  highlight: function(code, lang) {
    return code;
  }
});

export default {
  name: 'web_ai_application_process_optimization_index',
  components: {
    choosePointDialog
  },
  data() {
    return {
      isScrollingUp: false,
      cardForm: {},
      srcMaterials: ['PP-H', 'PP-R', 'PP-EVA', 'PP-MF'],
      defectList: [],
      defects: ['短射', '缩水', '飞边', '气纹', '熔接痕', '料花', '困气', '色差', '水波纹', '脱模不良', '顶白', '变形', '气泡', '阴阳面', '浇口印', '喷射纹', '烧焦', '尺寸偏小', '尺寸偏大'],
      products: ['手机外壳', '电风扇叶', 'USB套', '键帽'],
      chatLoading: false,
      shortCutKeys: ['工艺调优'],
      ws: null,
      messages: [],
      inputMsg: '',
      isConnected: false,
      reconnectAttempts: 0,
      conversationId: this.generateUUID(),
      token: '',
      isMsgStop: true,
      historyItems: [],
      historyIndex: -1,
      baseUrl: '',
      pointTableData: [],
      choosePointVisible: false,
      currentAnswer: ''
    };
  },
  created() {
    this.baseUrl = (process.env.NODE_ENV === 'development' ? global.URL_DEV_PAGE_BASE_DOMAIN : process.env.VUE_APP_SERVER === 'preview' ? global.URL_PRE_PAGE_BASE_DOMAIN : global.URL_PROD_PAGE_BASE_DOMAIN) + '/socket';
    console.log('baseUrl', this.baseUrl);
    this.token = localStorage.getItem('token');
    this.initWebSocket();
    this.getConversationList();
    this.getDefectList();
  },
  watch: {
    choosePointVisible(newVal, oldVal) {
      if (!newVal) {
        this.currentAnswer = '';
      }
    }
  },
  beforeDestroy() {
    this.closeWebSocket();
  },
  methods: {
    // 获取缺陷列表
    getDefectList() {
      this.http
        .get('/web/craft/defect/list')
        .then(res => {
          this.defectList = res.data || [];
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 下发工艺参数按钮
    sendPoint(item) {
      if (!this.cardForm.equipmentId) {
        this.$message.warning(this.$t('qingxuanzeshebei'));
        return;
      }
      this.currentAnswer = item.msg;
      this.choosePointVisible = !this.choosePointVisible;
    },
    // 点击快捷按钮
    handleShortCutKey(item) {
      this.inputMsg = item;
      this.sendMessage('1');
    },
    // 新建对话
    newConversation() {
      this.isMsgStop = true;
      this.historyIndex = -1;
      this.messages = [];
      this.inputMsg = '';
      this.conversationId = this.generateUUID();
    },
    // 选中会话
    selectItem(item, index) {
      if (!this.isMsgStop) {
        this.$message.success('消息正在接收中...');
        return;
      }
      if (this.historyIndex === index) {
        return;
      }
      this.historyIndex = index;
      this.conversationId = item.uuid;
      this.getConversationItemList(item.id, index);
    },
    // 获取会话项列表
    getConversationItemList(conversationId, index) {
      this.chatLoading = true;
      this.http
        .get('/web/chat/conversation/item/listByConversationId?conversationId=' + conversationId)
        .then(res => {
          const data = res.data || [];
          const messages = [];
          for (let i = 0; i < data.length; i++) {
            const d = data[i];
            const userMessage = {
              type: 'user',
              msg: d.userPrompt,
              conversationId: d.conversationUuid,
              conversationItemId: d.itemUuid,
              reasoningMsg: '',
              isError: false
            };
            const botMessage = {
              type: 'bot',
              msg: d.assistant,
              conversationId: d.conversationUuid,
              conversationItemId: d.itemUuid,
              reasoningMsg: d.reasoning,
              isError: false
            };
            messages.push(userMessage);
            messages.push(botMessage);
          }
          this.messages = messages;
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        })
        .finally(() => {
          this.chatLoading = false;
        });
    },
    // 获取会话列表
    getConversationList() {
      this.http
        .get('/web/chat/conversation/listByUser')
        .then(res => {
          const data = res.data || [];
          if (data.length > 0) {
            this.historyItems = data;
          }
        })
        .catch(err => {
          this.$message.error(this.$t(err));
        });
    },
    // 页面追加消息
    pushMessage(type, res) {
      if (type === 'user') {
        const message = {
          type: type,
          msg: this.inputMsg,
          conversationId: this.conversationId,
          conversationItemId: res.conversationItemId,
          reasoningMsg: '',
          isError: false
        };
        this.messages.push(message);
        this.inputMsg = '';
        this.messages.push({
          type: 'bot',
          msg: '',
          conversationId: this.conversationId,
          conversationItemId: res.conversationItemId,
          reasoningMsg: '',
          isError: false
        });
      } else if (type === 'bot') {
        // 如果消息数量是单数，说明还缺一条bot消息成对。先添加一条bot消息，后续再有一条bot消息时，会更新这条bot消息
        if (this.messages.length % 2 !== 0) {
          const message = {
            type: type,
            msg: res.isReasoning ? '' : res.msg,
            conversationId: res.conversationId,
            conversationItemId: res.conversationItemId,
            reasoningMsg: res.isReasoning ? res.msg : '',
            isError: res.isError
          };
          if (res.isError) {
            message.msg = res.msg;
            message.reasoningMsg = '';
          }
          this.messages.push(message);
        } else {
          const lastMessage = this.messages[this.messages.length - 1];
          if (lastMessage.conversationId === res.conversationId && lastMessage.conversationItemId === res.conversationItemId) {
            if (res.isReasoning) {
              let msg = lastMessage.reasoningMsg + res.msg;
              this.$set(lastMessage, 'reasoningMsg', msg);
            } else {
              let msg = lastMessage.msg + res.msg;
              this.$set(lastMessage, 'msg', msg);
            }
          }
        }
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // 发送消息
    sendMessage(promptType = '0') {
      if (!this.isMsgStop) {
        this.$message.success('消息正在接收中...');
        return;
      }
      if (this.inputMsg.trim() && this.isConnected) {
        try {
          const conversationItemId = this.generateUUID();
          const receiveBody = {
            token: this.token,
            promptType: promptType,
            conversationId: this.conversationId,
            conversationItemId: conversationItemId,
            prompt: this.inputMsg,
            attach: {
              equipmentId: this.cardForm.equipmentId,
              srcMaterial: this.cardForm.srcMaterial,
              product: this.cardForm.product,
              defectIds: this.cardForm.defectIds,
              remark: this.cardForm.remark
            }
          };
          this.ws.send(JSON.stringify(receiveBody));
          const res = {
            conversationItemId: conversationItemId
          };
          this.pushMessage('user', res);
        } catch (error) {
          console.error('发送消息失败:', error);
          this.reconnect();
        }
      }
    },
    // 初始化websocket
    initWebSocket() {
      try {
        this.ws = new SockJS(`${this.baseUrl}/process/optimization`);
        this.ws.onopen = () => {
          this.isConnected = true;
          this.reconnectAttempts = 0;
        };
        this.ws.onmessage = event => {
          let data = event.data;
          if (data) {
            data = this.decodeBase64Utf8(data);
            try {
              const res = JSON.parse(data);
              // 如果是结束消息，则停止接收消息
              if (res.isStop) {
                this.isMsgStop = true;
                // 如果是新会话，则刷新会话列表
                if (this.messages.length <= 2) {
                  this.getConversationList();
                }
                return;
              }
              this.isMsgStop = false;
              this.pushMessage('bot', res);
            } catch (e) {
              this.isMsgStop = true;
              console.error('WebSocket消息解析失败:', data, e);
            }
          }
        };
        this.ws.onerror = error => {
          console.error('WebSocket错误:', error);
          this.reconnect();
        };
        this.ws.onclose = () => {
          console.log('WebSocket连接已关闭');
          this.reconnect();
        };
      } catch (error) {
        console.error('WebSocket初始化失败:', error);
        this.reconnect();
      }
    },
    decodeBase64Utf8(base64String) {
      // 将 Base64 转换为二进制字符串
      const binaryString = atob(base64String);
      // 将二进制字符串转换为字节数组
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      // 使用 TextDecoder 解码 UTF-8
      return new TextDecoder('utf-8').decode(bytes);
    },
    // 关闭websocket
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        this.ws = null;
      }
    },
    // 重新连接websocket
    reconnect() {
      this.isMsgStop = true;
      this.isConnected = false;
      this.reconnectAttempts++;
      console.log(`尝试重新连接... (${this.reconnectAttempts})`);
      setTimeout(() => {
        this.initWebSocket();
      }, 2000);
    },
    // 渲染markdown
    renderMarkdown(content) {
      if (!content) {
        return '';
      }
      return marked(content);
    },
    // 生成uuid
    generateUUID() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
    },
    // 监听会话页面滚动
    handleScroll() {
      const container = this.$refs.messageContainer;
      // 判断用户是否在向上滚动
      this.isScrollingUp = container.scrollTop + container.clientHeight < container.scrollHeight;
    },
    // 会话页面滚动到底部
    scrollToBottom() {
      if (!this.isScrollingUp) {
        const container = this.$refs.messageContainer;
        container.scrollTop = container.scrollHeight;
      }
    }
  }
};
</script>
